class TrackingFinder extends HTMLElement{
  constructor(){
    super();

    this.orderID = 0;
    this.finder = this.getElementsByClassName("finder")[0];
    this.orderIDInputer = this.getElementsByClassName("orderid")[0];
    this.trackingNumber = this.getElementsByClassName("tracking-number")[0];
    this.trackingCompany = this.getElementsByClassName("tracking-company")[0];

    this.orderIDInputer.addEventListener("change", this.onEnterOrderID.bind(this));
    this.finder.addEventListener("click", this.findTracking.bind(this));
  }

  onEnterOrderID(e){
    let value = e.currentTarget.value.toUpperCase();
    if( ! value.startsWith("#") ){
      value = "#" + value;
    }

    this.orderID = value;
  }

  startFinding(){
    this.classList.add("loading");
    if(this.classList.contains("done"))
      this.classList.remove("done");
  }

  endFinding(){
    this.classList.remove("loading");
    this.classList.add("done");
  }

  findTracking(e){
    e.preventDefault();
    this.startFinding();
    console.log("finding tracking number on Order: " + this.orderID);

    let url = "https://devtools.eshoppinggroup.com/services/trackingfinder?orderid=" + encodeURIComponent(this.orderID) + "&store=" + Shopify.shop;

    fetch(url, {})
    .then(res => res.json())
    .then(res => { this.showResponse(res); this.endFinding() })
    .catch(error => { this.endFinding(); console.error("Error: ", error) });
    return false;
  }

  showResponse(res){
    if(res.number){

      if(res.url){
        let numberElement = document.createElement("a");
        numberElement.href = res.url;
        numberElement.innerText = res.number;
        numberElement.target = "_blank";

        this.trackingNumber.innerHTML = numberElement.outerHTML;
      }
      else{
        this.trackingNumber.innerText = res.number;
      }

      this.trackingCompany.innerText = res.company;
    }
  }
}

customElements.define("tracking-finder", TrackingFinder);